import { Card } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import ImageAvatar from "../../../../ui/components/ImageAvatar/ImageAvatar";

export default function ProductionOverviewInformationCard({ voices, production }) {
	const { t } = useTranslation();

	const { scriptDate, pages, deliveryDate } = production;

	return (
		<Card fluid>
			{Object.values(voices || {}).length > 0 && (
				<Card.Content>
					<Flex justifyContent="flex-start" gap={10}>
						{Object.values(voices || {}).map(({ offers }) =>
							offers.map(({ secondParty }) => {
								return (
									<Flex key={secondParty.id} justifyContent="flex-start" gap={10}>
										<ImageAvatar style={{ width: 30, height: 30 }} src={secondParty.img} />
										<p>
											<strong>{secondParty.name}</strong> ({t("suggested", "Suggested")})
										</p>
									</Flex>
								);
							}),
						)}
					</Flex>
				</Card.Content>
			)}

			{(scriptDate || pages || deliveryDate) && (
				<Card.Content>
					<Flex justifyContent="flex-start" gap={30}>
						{scriptDate && (
							<div>
								<strong>{t("scriptDateTodo", "Script date")}:</strong>{" "}
								{scriptDate?.toDate?.()?.toLocaleDateString()}
							</div>
						)}

						{pages && (
							<div>
								<strong>{t("pages", "Pages")}:</strong> {pages}
							</div>
						)}

						{deliveryDate && (
							<div>
								<strong>{t("delDate", "Delivery date")}:</strong>{" "}
								{deliveryDate?.toDate?.()?.toLocaleDateString()}
							</div>
						)}
					</Flex>
				</Card.Content>
			)}
		</Card>
	);
}
